import type { EventPayload, UserProps } from '@usermaven/sdk-js';
import type { Usermaven } from './types';

export const UsermavenClientMocked: Usermaven = {
  id: async (userData: UserProps, doNotSendEvent = false) => {},
  track: async (typeName: string, payload?: EventPayload) => {},
};
